
import { defineComponent,ref } from 'vue'
import { onBeforeRouteUpdate,useRouter,useRoute } from 'vue-router'

import TopBar from '@/components/TopBar.vue'
export default defineComponent({
    components:{
        TopBar
    },
    setup() {
        const router = useRouter()
        const route = useRoute()
        const viewIndex = ref(1)

        const caseView = (value:string) => {
            switch (value) {
                case '/UploadView':
                    viewIndex.value = 1
                    break;
                case '/BankView':
                    viewIndex.value = 2
                    break;
                default:
                    break;
            }
            return viewIndex
        }
        caseView(route.path)
        onBeforeRouteUpdate((to) => {
            caseView(to.path)
        })
        const changeView = (path:string) => {
            router.push({path:path})
        }
        return {
            viewIndex,
            changeView
        }
    },
})
